export default {
  sample_selected: null,
  samples: [],
  area_selected: null,
  soilAreas: [],
  isShowAll: false,
  samplesGuide: [],
  kitType: null,
  samplingPoints: [],
};
